import React, { useState } from 'react';
// import PropTypes from 'prop-types';
// import { useForm } from 'react-hook-form';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CircularProgress from '@mui/material/CircularProgress';
// import TextField from '@mui/material/TextField';
import ib_logo from '../../img/ib-circle-logo.png'
import { useRedirect, Form, useNotify, TextInput, /* Create */ } from 'react-admin';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';
import { API_ROOT } from '../../transport-layer'
import makeStyles from '@mui/styles/makeStyles';
import { useClientContext } from 'contexts/client';


const userFormStyles = makeStyles(theme => ({
    main: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'flex-start',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    },
    modal: {

    },
    card: {
        minWidth:450,
        marginTop: '6em',
    },
    modalCard: {
        minWidth:450,
        
    },
    avatar: {
        margin: '1em',
        display: 'flex',
        justifyContent: 'center',
    },
    icon: {
        // backgroundColor: theme.palette.secondary.main,
    },
    hint: {
        marginTop: '1em',
        display: 'flex',
        justifyContent: 'center',
        // color: theme.palette.grey[500],
    },
    form: {
        padding: '0 1em 1em 1em',
    },
    input: {
        marginTop: '1em',
    },
    actions: {
        padding: '0 1em 1em 1em',
    },
}));

// const renderInput = ({
//     meta: { touched, error } = { touched: false, error: undefined },
//     input: { ...inputProps },
//     ...props
// }) => (
//         <TextField
//             error={!!(touched && error)}
//             helperText={touched && error}
//             {...inputProps}
//             {...props}
//             fullWidth
//         />
//     );

interface FormValues {
    email?: string;
    name?: string;
}

// const { Form } = withTypes<FormValues>();

const RegisterForm = (props:any) => {
    const [loading, setLoading] = useState(false);
    const classes = userFormStyles();
    const notify = useNotify();
    const { state: client } = useClientContext()
    const CLIENT = client.client.resourcePrefix
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [ alreadyRegistered ] = useState(false)
    const redirect = useRedirect()
    const clientLogo = client.client.logo
    const handleSubmit = (formVals: FormValues) => {
        setLoading(true);
        fetch(`${API_ROOT}/rpc/register`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ...formVals,
                client: CLIENT
            })
        })
            .then((e:any) => {
                if (e.status === 200) {
                    return e.json();
                }
                else
                {
                    
                    // eslint-disable-next-line no-throw-literal
                    throw `error with status ${e.status}`;
                }
            })
            .then((e:any) => {
                
                if (e.response === 'Registration Sent') {
                    notify('Registration Request Sent');
                    if (props.redirect) {
                        redirect('/registration_started');
                    }                    
                } else {
                    
                }
                
            })
            .catch((e) => {
                // notify('Error: could not complete your request', 'warning')
                notify('User already registered');
            })
            .finally(() => {
                setLoading(false);
                props.onComplete()
            });
    };

    // const validate = (values: FormValues) => {
    //     const errors: FormValues = {};
    //     if (!values.email) {
    //         errors.email = "Email Required";
    //     }
    //     if (!values.name) {
    //         errors.name = "Name Required";
    //     }
    //     return errors;
    // };
    
    return (
                <Form onSubmit={handleSubmit} noValidate>
                    <div className={(props.showLogos) ? classes.main : classes.modal}>
                        <Card className={(props.showLogos) ? classes.card : classes.modalCard}>
                        {(props.showLogos) ?
                            <div className={classes.avatar}>
                                <img src={clientLogo} alt="Logo" height={'100px'} />
                            </div>
                        : null }
                            {(!alreadyRegistered) ?
                            <React.Fragment>
                            <div className={classes.form}>

                            <Typography variant="body2" gutterBottom>
                                {(props.showInfo) ? 'Please enter your email address below and we will send you a link which can be used to confirm your account and complete the setup process.' : ''}
                            </Typography>
                                <div className={classes.input}>
                                    <TextInput
                                        autoFocus
                                        source="name"
                                        // @ts-ignore
                                        // component={renderInput}
                                        label={'FULL NAME'}
                                        disabled={loading}
                                        
                                    />
                                </div>
                                <div className={classes.input}>
                                    <TextInput
                                        autoFocus
                                        source="email"
                                        // @ts-ignore
                                        // component={renderInput}
                                        label={'EMAIL ADDRESS'}
                                        disabled={loading}
                                        type="email"
                                    />
                                </div>

                            </div>
                            <CardActions className={classes.actions}>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    disabled={loading}
                                    fullWidth
                                >
                                    {loading && (
                                        <CircularProgress
                                            size={25}
                                            thickness={2}
                                        />
                                    )}
                                    {'Register'}
                                </Button>
                            </CardActions>
                           </React.Fragment>
                            :
                            <div className={classes.form}>
                                <Typography variant="body2" gutterBottom>
                                    It appears you are already registered.
                                    If you forgot your password you can reset it <Link component={RouterLink} to={'/forgot_password'}>here</Link>
                                </Typography>
                            </div>
                            
                            }
                            
                        </Card>
                        
                    </div>
                    {(props.showLogos) ?
                        <div style={{ position: 'absolute', 'bottom': 10, 'left': '10px' }}>
                            <img src={ib_logo} height='35px' alt='infobate-logo' />
                        </div>                    
                    : null}

                    {/* <Notification /> */}
                </Form>
    );
};

// RegisterForm.propTypes = {
//     // authProvider: PropTypes.func,
//     previousRoute: PropTypes.string,
//     showLogos: PropTypes.any,
//     showInfo: PropTypes.any,
//     redirect: PropTypes.any,
//     onComplete: PropTypes.func
// };

// We need to put the ThemeProvider decoration in another component
// Because otherwise the useStyles() hook used in Register won't get
// the right theme


export default RegisterForm;